import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./styles.scss";

import { logout } from "../../redux/action/admin.actions";
import { useEffect } from "react";

const OptionsToolBar = ({ history, state,}) => {

// Redux
const dispatch = useDispatch();

  //Metodos
  useEffect(() => {
    console.log("ver lo del auth", state);
  
  }, [])
  


  const clickExit = () => {
    console.log(" --ToolBar.clickExit-- ");
    window.sessionStorage.clear();
    window.localStorage.clear();
    dispatch(logout());
    history.push("/");
  };



  // Return
  return (
    <ul className={`dropdown-content ${state === null ? '' : 'active'}`}>
    <li>
    <Link to="/perfil">Perfil</Link>
    </li>
    <li>
    <Link to="/newmensajeria">Mensajería</Link>

    </li>
    <li>
    <Link to="/newservice">Servicio Hogar/ Oficina</Link>
    </li>
    <li>
      <hr/>
    <Link onClick={clickExit}   href = '/#'> Cerrar Sesion</Link>

    </li>
    </ul>
  );
};
export default OptionsToolBar;
